// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../css-global/colors.scss\"","_green":"#587f4c","root":"BrowserBanner-module--root--EkKxi"};